import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { spacing } = tokens;

const BrandIconMobile = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 48 48'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <defs>
                <style>{'.Mobile_svg__cls-1{fill:#002664}'}</style>
            </defs>
            <path
                className='Mobile_svg__cls-1'
                d='M35 40h-4v-2h3V6H14v32h3v2h-4a1 1 0 01-1-1V5a1 1 0 011-1h22a1 1 0 011 1v34a1 1 0 01-1 1z'
            />
            <path d='M24 44a5 5 0 115-5 5 5 0 01-5 5z' fill='#d7153a' />
            <path
                className='Mobile_svg__cls-1'
                d='M35 48H13a5 5 0 01-5-5V5a5 5 0 015-5h22a5 5 0 015 4.87V43a5 5 0 01-5 5zM13 2a3 3 0 00-3 3v38a3 3 0 003 3h22a3 3 0 003-3V5a3 3 0 00-3-3z'
            />
        </svg>
    );
};

BrandIconMobile.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['lg', 'xl', 'xxl']),
};
BrandIconMobile.defaultProps = {
    size: 'xl',
    focusable: false,
};
export default BrandIconMobile;
